// ChatBubble.tsx — shell de chat del onboarding de Novah.
// Qué hace: renderiza la lista de burbujas (novah/user) con el avatar y el
//   indicador de "typing". Mantiene el render idéntico al original (incluido el
//   dangerouslySetInnerHTML para **negritas**).
// Qué exporta: ChatBubbles.
// Quién lo usa: CreateWorkspaceModal (chat shell).

import { RefObject } from 'react';
import { ChatMsg } from './types';
import { ChatContainer, MsgRow, Avatar, Bubble, TypingDots } from './styled';

interface Props {
  messages: ChatMsg[];
  typing: boolean;
  scrollRef: RefObject<HTMLDivElement>;
}

export function ChatBubbles({ messages, typing, scrollRef }: Props) {
  return (
    <ChatContainer>
      {messages.map(msg => (
        <MsgRow key={msg.id} $from={msg.from}>
          {msg.from === 'novah' && (
            <Avatar><img src="/novah_laugh.png" alt="Novah" /></Avatar>
          )}
          <Bubble $from={msg.from} dangerouslySetInnerHTML={{ __html: msg.text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>') }} />
        </MsgRow>
      ))}
      {typing && (
        <MsgRow $from="novah">
          <Avatar><img src="/novah_laugh.png" alt="Novah" /></Avatar>
          <Bubble $from="novah"><TypingDots><span /><span /><span /></TypingDots></Bubble>
        </MsgRow>
      )}
      <div ref={scrollRef} />
    </ChatContainer>
  );
}
